import Swiper, { Lazy, Navigation, Pagination } from 'swiper'

export const init = async function () {
  // configure Swiper to use modules
  Swiper.use([Navigation, Pagination, Lazy])

  new Swiper('.js-article-carousel', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    lazy: true,
    slidesPerView: 'auto',
    spaceBetween: 24
  })
}
